module.exports = __webpack_public_path__ + "assets/images/small-multiples/desktop.svg?v=478735e5";